// import React, { Component } from "react";
import Slider from "react-slick";

import { Container } from "react-bootstrap";
import   Image from "react-bootstrap/Image";
import './Partners.css';
import React from 'react';

function Partners() {
    const settings = {
        lazyLoad:true,
        dots: false,
        infinite: true,
        autoplay: true,
        //   cssEase:'linear',
        speed: 400,
        autoplaySpeed:900,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide:1,
    };
    return (
        <div id="partners">
                <Container className="my-5">
                <h2 className="partners__header my-4" >
                    Our insurance Partners
                    
                </h2>
                <Slider {...settings}>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()} alt="mtiba" src="/images/insurance/mtiba.jpg"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()} alt="aar" src="/images/insurance/aar.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()}  alt="apa" src="/images/insurance/apa.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()}  alt="cic" src="/images/insurance/cic.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()}  alt="cop" src="/images/insurance/cop.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()}alt="minet" src="/images/insurance/minet.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()}  alt="nhif" src="/images/insurance/nhif.jpg"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image  fluid={true.toString()} alt="kcb" src="/images/insurance/kcb.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image  fluid={true.toString()} alt="jubilee" src="/images/insurance/jubilee.png"/>
                    </div>
                    
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()} alt="mpesa" src="/images/insurance/mpesa.png"/>
                    </div>
                    <div style={{height:"200px"}} className="image_container">
                        <Image fluid={true.toString()} alt="britam" src="/images/insurance/britam.jpg"/>
                    </div>
                </Slider>
            </Container>
        </div>
    );
}

export default Partners;
